module.exports = __webpack_public_path__ + "static/media/talan-logo 2.f344b6b7.png";